import { useSelector } from "react-redux";
import { selectCurrent } from "../../../../../../redux/settings/selectors";
import { FormattedMessage } from 'react-intl';
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../../../hooks/hooks";
import Table from "../../../../../../common/components/table";
import { agents } from "../../../../../../redux/agents/action";
import { selectAgentsListItems } from "../../../../../../redux/agents/selector";

const TransporterAgents = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
	const result = useSelector(selectCurrent)
	const { header, footer, currency } = result
    const orderItems = useSelector(selectAgentsListItems)
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
          { field: 'Name', headerName: 'Name', sortable: true, filter: true,isEdit: true },
          { field: 'PhoneNumber', headerName: 'Phone Number' },
          { field: 'TransportAgentNumber', headerName: 'TransportAgent Number', sortable: true, filter: true },
          { field: 'CreatedOnUtc', headerName: 'Created On' },
            { field: 'ModifiedOnUtc', headerName: 'Modified On' },
        ]);
      }
      const fetchAgents=()=>{
        dispatch(agents.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/transport-agents/list`,entity:'agents',jsonData:{
          "PageNumber": pageData,
        "PageSize": 10,
        "SortField": "Id",
        "SortOrder": "desc",
      }}))
      }
	useEffect(() => {
        createColumnDefs()
        fetchAgents()
	}, [pageData])

	return (
  
		<Table columnData={columnDefs} rowData={orderItems?.result?.items} setPageData={setPageData}
    paginationData={orderItems?.result?.pagination} headingName="Agents"/>
     
     
	);
};

export default TransporterAgents;


